var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClothes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.05 8 .98-.199L11.867 7h-.817v1Zm4.9 0V7h-.817l-.163.801.98.199Zm-8.7 1h3.8V7h-3.8v2ZM8 8.25a.75.75 0 0 1-.75.75V7C6.56 7 6 7.56 6 8.25h2ZM8 20V8.25H6V20h2Zm0 0H6a2 2 0 0 0 2 2v-2Zm11 0H8v2h11v-2Zm0 0v2a2 2 0 0 0 2-2h-2Zm0-11.75V20h2V8.25h-2Zm.75.75a.75.75 0 0 1-.75-.75h2C21 7.56 20.44 7 19.75 7v2Zm-3.8 0h3.8V7h-3.8v2Zm-.98-1.199A1.5 1.5 0 0 1 13.5 9v2a3.5 3.5 0 0 0 3.43-2.801L14.97 7.8ZM13.5 9a1.5 1.5 0 0 1-1.47-1.199l-1.96.398A3.5 3.5 0 0 0 13.5 11V9Z",
    fill: "#434443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.01V13H4.366c-.676 0-1.16-.659-.934-1.296C4.426 8.897 5.275 7.884 7 8.01ZM20 8.01V13h2.634c.676 0 1.16-.659.934-1.296-.994-2.807-1.843-3.82-3.568-3.694Z",
    stroke: "#434443",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClothes);
export default __webpack_public_path__ + "static/media/icon-clothes.9de1ee7279c554787525138d61b29279.svg";
export { ForwardRef as ReactComponent };